export const fieldLabels = {
  currentCompliant:
    "Complete the following declaration in relation to your organisation's current compliance.",
  currentCompliantYes:
    "We are currently compliant with all Conditions of Recognition (including the Vocational and Technical Qualifications Contingency Regulatory Framework (VCRF) from Ofqual/CCEA Regulation/Qualifications Wales where applicable).",
  currentCompliantNo:
    "We are not currently compliant with all Conditions of Recognition (including the Vocational and Technical Qualifications Contingency Regulatory Framework (VCRF) from Ofqual/CCEA Regulation/Qualifications Wales where applicable).",
  currentCompliantDate:
    "Please select the date by which you will become compliant.",
  currentNonComplianceDescription:
    "Please describe the instance of non-compliance",
  currentNonComplianceMitigation:
    "Please describe how you plan to address this non-compliance.",
  futureCompliant:
    "Complete the following declaration in relation to your organisation's future compliance.",
  futureCompliantYes:
    "We believe that we are likely to be compliant in the next 12 months with all Conditions of Recognition (including the Vocational and Technical Qualifications Contingency Regulatory Framework (VCRF) from Ofqual/CCEA Regulation/Qualifications Wales where applicable).",
  futureCompliantNo:
    "We believe that we are likely to fail to fully comply with all Conditions of Recognition in the next 12 months (including the Vocational and Technical Qualifications Contingency Regulatory Framework (VCRF) from Ofqual/CCEA Regulation/Qualifications Wales where applicable).",
  futureNonComplianceDescription:
    "Please describe the instance of potential non-compliance.",
  futureNonComplianceMitigation:
    "Please describe how you plan to address this potential non-compliance.",
  futureNonComplianceHow:
    "Please explain how you know you are likely to fail to comply.",
  currentRevenueIncome: "Revenue/income",
  currentExpenditure: "Expenditure",
  currentProfitSurplus: "Profit/surplus",
  currentCashLiquidReserves: "Cash and other liquid reserves",
  currentNumberOfEmployees: "Number of employees",
  currentNumberOfContractors: "Number of contractors",
  furtherInformation: "Further Information",
  forecastRevenueIncome: "Revenue/income",
  forecastExpenditure: "Expenditure",
  forecastProfitSurplus: "Profit/surplus",
  forecastCashLiquidReserves: "Cash and other liquid reserves",
  forecastNumberOfEmployees: "Number of employees",
  forecastNumberOfContractors: "Number of contractors",
  itRiskManagementMitigation:
    "Considering your obligations under Conditions A5 and A6, please outline how your organisation mitigates and manages cyber security and data security risks.",
  itInsiderRiskMitigation: "Insider risks",
  epaOffered:
    "Do you offer apprenticeship end-point assessments regulated by Ofqual?",
  epaChallengeInCompliance:
    "What risks or challenges do you face in ensuring your compliance with the requirements of the Assessment Plan(s) you offer?",
  epaMitigationsDescription:
    "What mitigations do you have in place to manage these?",
  epaTrainingOffered:
    "Do you offer training to apprenticeship training providers or employers regarding the End Point Assessments you offer?",
  epaMaterialOffered:
    "Do you provide support materials to training providers or employers regarding the End Point Assessments you offer? In this context, support materials might include, but are not limited to, sample tests, practice questions, submission templates or other materials you provide to training providers or employers to help them prepare their apprentices for the EPA.",
  govBodyConfirmCompliance:
    "1. I confirm that the Statement of Compliance is accurate.",
  govBodyNoCompliance: "Non compliance statement",
  govBodyConfirmApproval:
    " 2. I confirm our Governing Body has formally approved the Statement of Compliance submission. I also confirm that, if requested, I am able to produce documents to verify that the Statement of Compliance was formally approved by the Governing Body.",
  govBodyConfirmNoApproval: "Non approval statement",
  govBodyConfirmChairRo:
    "3. Please confirm that both the Chair of the Governing Body and the Responsible Officer have signed off the Statement of Compliance submission. I also confirm that, if requested, I am able to produce documents to verify that the Statement of Compliance submission has been signed off by the Chair of the Governing Body and the Responsible Officer).",
  govBodyConfirmNoChairRo: "Non conformity statement",
  govBodyConfirmNameRo:
    "Please confirm the name of the Responsible Officer that signed off the Statement of Compliance:",
  govBodyConfirmNameChair:
    "Please confirm the name of the Chair of your Governing Body that signed off the Statement of Compliance:",
  govBodyConfirmSigningOnBehalfName: "Name",
  govBodyConfirmSigningOnBehalfTitle: "Job title",
  monthlyFixedCost: "Your monthly fixed operating costs",
  monthlyCoverage:
    "How many months cover does your current reserve balance equate to?",
  reserveThresholdLevel:
    "Is the current level of reserves above the minimum reserves threshold stated in your policy?",
  planToBuildReserve:
    "If reserves are below the minimum threshold, do you have a plan to build your reserves. If yes, please provide details.",
  planToBuildReserveDetails: "Additional details",
  inflationMitigationDetails: "Risk mitigation details",
  financialRisk: "Financial risk details",
  thirdPartyArrangement:
    "Do you have any existing or planned arrangements in place with third parties? Y/N",
  thirdPartyComplySummary:
    "Please provide a summary of how you evaluate a third party’s ability and willingness to act in a way that will enable you to comply with the conditions before entering an arrangement with them",
  thirdPartyInHouseSummary:
    "Please provide further information on how you manage all processes in house",
  thirdPartyArrangementNature:
    "Please explain the nature of your arrangement with third parties. For example are they informal agreements or formal contracts?",
  thirdPartyArrangementNatureSummary:
    "Please explain the nature of your arrangement with third parties. For example are they informal agreements or formal contracts?",
  thirdPartyExpectation:
    "How do you make clear to the third parties what you expect of them?",
  thirdPartyMonitorContingency: "Risk assess and review your arrangements with a third party, including any contingency plans should one cease to operate at short notice",
  thirdPartyMonitorContinuity: "Monitor whether a third party has appropriate risk management and business continuity plans",
  thirdPartyMonitorBreach: "Manage a failure in any agreement in place with a third party? For example, a breach of contract or failure against any Service Level Agreements",
  thirdPartyMonitorPerformance: "Manage poor performance of the third-party",
  sharedOperationFinance:
    "Do you have any shared ownership and/or operational, financial, resource, personnel, or governance arrangements with any centres? Y/N",
  conflictOfInterestIdentification:
    "If yes, how do you identify, review, monitor and manage conflict of interest in this area to ensure compliance with Condition A4: Conflicts of interest?",
  prohibitedTrainingFrequency:
    "How frequently is it delivered, and in what format?",
  prohibitedTrainingContent:
    "Please give an overview of the content covered in this training, including who delivers it.",
  prohibitedTrainingComplianceDescription:
    "In undertaking this training, how do you ensure compliance with our general Condition G4: Maintaining confidentiality of assessment materials?",
  prohibitedTrainingMaterialFrequency:
    "How frequently are these provided, and in what format?",
  prohibitedTrainingMaterialContent:
    "Please give an overview of the content covered in these materials.",
  prohibitedTrainingMaterialComplianceDescription:
    "In providing these materials, how do you ensure compliance with our general Condition G4: Maintaining confidentiality of assessment materials?",
};

export const fieldLabelsOfqual = {
  agreeCurrentCompliant: "Agree with AO current compliance declaration",
  agreeFutureCompliant: "Agree with AO future compliance declaration",
  complianceDisagreement:
    "Reasons for disagreement with compliance declaration",
  complianceDisagreementDescription: "Reasons for disagreement description",
  complianceRagRating: "RAG rating - current and future compliance",
  standardsFollowUp: "Standards follow up",
  standardsFollowUpStatus: "Standards follow up status",
  standardsClosureStatus: "Standards closure status",
  organisationalStabilityRagRating: "RAG rating - organisational stability",
  organisationFollowUpStatus: "Organisation follow up status",
  organisationFollowUp: "Organisation follow up",
  ragRating: "Rag rating",
  followUp: "Follow up",
  followUpStatus: "Follow up status",
  lead: "Lead",
  riskMarketsClosureStatus: "Risk and Markets closure status",
  followUpLead: "Follow up lead",
  closingStatus: "Closing status",
  closingStatusRationale: "Closing status rationale",
  overallRagRating: "Overall RAG rating",
  meetingDate: "Event meeting date",
  eventType: "Event type",
  closeReason: "Reason",
  regComplianceClosureStatus: "Regulatory Compliance closure status",
  endpointAssessmentClosureStatus: "End Point Assessment closure status",
};
